import React, { useEffect, useState, useRef, Fragment } from "react"
import { Modal } from "react-bootstrap"
import { useLocation, useNavigate } from "react-router-dom"
import { parse } from "query-string"
import { useDispatch } from "react-redux"
import { FaCheckCircle, FaTimesCircle } from "react-icons/fa"
import { useTranslation } from "react-i18next"

import { Button } from "components"
import { billplzPaymentStatus } from "services"
import { fetchSystemSettings, fetchWalletDetails } from "@redux"
import classes from "./TopupResultModal.module.scss"

const TopupResultModal = () => {
  const [t] = useTranslation()

  const dispatch = useDispatch()

  const navigate = useNavigate()

  const location = useLocation()

  const query = parse(window.location.search)

  const [paymentResult, setPaymentResult] = useState(null)
  const [openTopupResultModal, setOpenTopupResultModal] = useState(true)

  const timeout = useRef(null)

  const handleDone = async () => {
    dispatch(
      fetchWalletDetails()
    )

    dispatch(
      fetchSystemSettings()
    )

    setOpenTopupResultModal(false)

    navigate(location.pathname, { replace: true })
  }

  const isPaymentFailed = () => {
    const failed = query["haghighi"] === "true"
      ? query["HaghighiStatus"] !== "succeeded"
      : query["ZarinpalStatus"] !== "OK"

    if (failed) {
      setPaymentResult(false)

      return true
    }

    return false
  }

  const checkBillplz = async () => {
    try {
      const { paymentStatus } =
        await billplzPaymentStatus(query["pId"])

      if (paymentStatus !== "paid") return

      setPaymentResult(true)

      clearInterval(timeout.current)
    } catch (err) {
      console.log(err)
    }
  }

  const handleEnter = () => {
    if (isPaymentFailed()) return

    timeout.current =
      setInterval(() => checkBillplz(), 1000)
  }

  useEffect(() => {
    return () => clearInterval(timeout.current)
  }, [])

  return (
    <Modal
      onEnter={handleEnter}
      show={openTopupResultModal}
      onHide={() => setOpenTopupResultModal(false)}
      backdrop="static"
      centered
    >
      <div className={classes["container"]}>
        {paymentResult === null
          ?
          <div className={classes["please-wait"]}>
            <h3>{t("لطفا_منتظر_بمانید")}</h3>
          </div>
          :
          <Fragment>
            {paymentResult
              ?
              <div className={classes["success"]}>
                <FaCheckCircle className={classes["icon"]} />
                <div className={classes["text"]}>
                  {t("شارژ_با_موفقیت_انجام_شد")}
                </div>
              </div>
              :
              <div className={classes["fail"]}>
                <FaTimesCircle className={classes["icon"]} />
                <div className={classes["text"]}>
                  {t("شارژ_انجام_نشد")}
                </div>
              </div>
            }
            <div className={classes["footer"]}>
              <Button
                color="success"
                onClick={handleDone}
              >
                {t("تایید")}
              </Button>
            </div>
          </Fragment>
        }
      </div>
    </Modal>
  )
}

export default TopupResultModal
